import PlanningPage from './pages/components/Planning.jsx';
import IndexApp from './pages/IndexApp.jsx';

export const Layout = IndexApp;
export const BuyingPlan = PlanningPage;
